import { render, staticRenderFns } from "./AddPaymentMethodButton.vue?vue&type=template&id=9d7a04ec&scoped=true"
import script from "./AddPaymentMethodButton.vue?vue&type=script&lang=ts"
export * from "./AddPaymentMethodButton.vue?vue&type=script&lang=ts"
import style0 from "./AddPaymentMethodButton.vue?vue&type=style&index=0&id=9d7a04ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a04ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d7a04ec')) {
      api.createRecord('9d7a04ec', component.options)
    } else {
      api.reload('9d7a04ec', component.options)
    }
    module.hot.accept("./AddPaymentMethodButton.vue?vue&type=template&id=9d7a04ec&scoped=true", function () {
      api.rerender('9d7a04ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AddPaymentMethodButton.vue"
export default component.exports